export default __webpack_public_path__ + "static/media/05.99a089d1.png";